/**
 * Inaugural 90-day protocol banner (PDP).
 *
 * Replaces the text-only protocol card with the campaign artwork for the two
 * live SKUs. Clicking it selects the qualifying protocol quantity in the pack
 * selector — the offer itself is still owned by the shared pricing resolver,
 * this is presentation only.
 */
import magDesktop from "@/assets/hero-v3/mag-inaugural-desktop.webp.asset.json";
import magMobile from "@/assets/hero-v3/mag-inaugural-mobile.webp.asset.json";
import liverDesktop from "@/assets/hero-v3/liver-inaugural-desktop.webp.asset.json";
import liverMobile from "@/assets/hero-v3/liver-inaugural-mobile.webp.asset.json";
import { cn } from "@/lib/utils";

const ART: Record<string, { desktop: string; mobile: string; alt: string }> = {
  "mag-absorb-pro": {
    desktop: magDesktop.url,
    mobile: magMobile.url,
    alt: "TruWe Mag Absorb Pro 90-day inaugural protocol — buy 2 months, get month 3 on us. 3 bottles, 180 tablets for ₹2,718 instead of ₹4,077. Offer ends 20 September 2026.",
  },
  "liver-biome-plus": {
    desktop: liverDesktop.url,
    mobile: liverMobile.url,
    alt: "TruWe Liver Biome Plus 90-day inaugural protocol — buy 2 months, get month 3 on us. 3 bottles, 180 tablets for ₹3,438 instead of ₹5,157. Offer ends 20 September 2026.",
  },
};

export function hasInauguralArt(handle: string) {
  return Boolean(ART[handle]);
}

export default function InauguralOfferBanner({
  handle,
  onSelect,
  selected,
  className,
}: {
  handle: string;
  onSelect: () => void;
  selected: boolean;
  className?: string;
}) {
  const art = ART[handle];
  if (!art) return null;

  return (
    <button
      type="button"
      onClick={onSelect}
      aria-pressed={selected}
      className={cn(
        "group block w-full overflow-hidden rounded-2xl border bg-background text-left transition",
        selected ? "border-brand ring-2 ring-brand/30" : "border-border hover:border-brand/50",
        className,
      )}
    >
      <picture>
        <source media="(min-width: 768px)" srcSet={art.desktop} type="image/webp" />
        <img
          src={art.mobile}
          alt={art.alt}
          width={1600}
          height={900}
          loading="lazy"
          decoding="async"
          className="h-auto w-full"
        />
      </picture>
    </button>
  );
}
